module.exports = __webpack_public_path__ + "assets/img/box9-img.bac7b38b.png";